import { createReducer, createSelector } from 'redux-starter-kit';
import { putTaxRates, putTaxRate, removeTaxRate } from './taxRateActions';


/**
 * A selector for the taxRates loaded in the domain state.
 * This is a keyed object: { date: taxRate, ... }
 * @param {object} state The redux state of the application.
 * @returns A keyed object of the tax rates.
 * @example const taxRate = selectTaxRates(state)[date];
 */
export const selectTaxRateMap = state => state.via.domain.taxRates;


/**
 * A selector for the inspection outcomes loaded in the domain state.
 * This is a list: [ outcome, outcome, ...]
 * @param {object} state The redux state of the application.
 * @returns An array of inspection outcomes.
 * @example const outcomes = selectOutcomes(state);
 */
export const selectTaxRates = createSelector(['via.domain.taxRates'], map => (map ? Object.values(map) : null));

/**
 * A selector for an inspection outcome that is loaded in the domain state.
 * @param {object} state The redux state of the application.
 * @param {number} outcomeCode The id of the outcome.
 * @example const outcome = selectOutcome(state, outcomeCode);
 */
export const selectTaxRate = (state, date) => {
  const taxRateMap = selectTaxRateMap(state);
  if (!taxRateMap) return null;

  return taxRateMap[date];
};


const initialTaxRateState = {
  /* dateFrom: taxRate */
};

export default createReducer(initialTaxRateState, {
  // Replace all the tax rates in the state.
  [putTaxRates]: (state, action) => {
    const taxRates = action.payload;

    // Builds a dict object. damageAreaCode => damageArea
    return taxRates.reduce((newState, taxRate) => {
      newState[new Date(taxRate.dateFrom).getTime()] = taxRate; // eslint-disable-line no-param-reassign
      return newState;
    }, { ...initialTaxRateState });
  },

  // Replace a single tax rate in the state.
  [putTaxRate]: (state, action) => {
    const taxRate = action.payload;

    return {
      ...state,
      [new Date(taxRate.dateFrom).getTime()]: taxRate,
    };
  },

  // Remove a single tax rate from the state.
  [removeTaxRate]: (state, action) => {
    const { [action.payload]: taxRate, ...rest } = state;
    return rest;
  },
});
